import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { formTrim } from './index'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL:  process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  if(config.data){
    config.data = formTrim(config.data)
  }

  if(config.params){
    config.params =formTrim(config.params)
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    const res = response.data
    // console.log(res)
    if (res.code != 200) {
      if(res.code == 502){
        Message({
          message: res.message,
          type: 'warning',
          duration: 3 * 1000
        })
      }else if(res.code == 400){
        Message({
          message: '请检查你的参数',
          duration: 3 * 1000
        })
      }else if(res.code == 405){
        Message({
          message: '请检查你的请求类型',
          duration: 3 * 1000
        })
      }else if(res.code == 403){
        Message({
          message: '抱歉，您没有访问权限',
          duration: 3 * 1000
        })
      }else if(res.code == 500){
        Message({
          message: '服务器打瞌睡了',
          type: 'error',
          duration: 3 * 1000
        })
      }else{
        Message({
          message: '程序发成了不可预知的错误，请联系管理员',
          type: 'warning',
          duration: 3 * 1000
        })
      }
      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出或者登录已过期，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    // console.log('err' + error)// for debug
    Message({
      message: '程序发成了不可预知的错误，请联系管理员',
      type: 'warning',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js